namespace $.$$ {
	export class $mol_tag_tree_demo extends $.$mol_tag_tree_demo {

		item_title( path: readonly string[] ) {
			return path.at(-1)!
		}
		
	}
}
